
export const keys = {
    all: ["scheduled-reports"],
    taskList: (
        organizationID: number,
        groupID: number
    ) => [
        ...keys.all,
        "task-list", {
            organizationID,
            groupID,
        }
    ],
    task: (
        groupID: number,
        taskID: number,
        myReports: boolean
    ) => [
        ...keys.all,
        "task", {
            groupID,
            taskID,
            myReports
        }
    ],
    notifications: (
        groupID: number,
    ) => [
        ...keys.all,
        "notifications", {
            groupID
        }
    ],

};
